<footer>
  <hr>
  <div style="display: flex; justify-content: center;">
    2018 - {{ currentYear }} ©
    <a href="http://www.crezcamos.com" target="_blank" rel="noreferrer noopener">
      Crezcamos S.A.
    </a>
    Todos los derechos reservados |
    Desarrollado por&nbsp;
    <a href="https://hexasolutions.co/">Hexasolutions</a> -
    <strong style="font-family: monospace;">
      v{{ 'LBL_VERSIONSISTEMA' | translate }}
    </strong>
  </div>
</footer>

